import React from "react";

const IconTextToolTip = () => (
	<svg width="31" height="28" viewBox="0 0 31 28" fill="white" xmlns="http://www.w3.org/2000/svg">
		<path d="M26.8599 0.157227H5.10883C2.83466 0.157227 0.984375 2.00751 0.984375 4.28168V17.5929C0.984375 19.8627 2.8266 21.7097 5.09418 21.7173V27.7582L13.7747 21.7179H26.8599C29.1341 21.7179 30.9844 19.8676 30.9844 17.5929V4.28168C30.9844 2.00751 29.1341 0.157227 26.8599 0.157227ZM22.9548 15.6265H9.01392V13.8687H22.9548V15.6265ZM22.9548 11.8765H9.01392V10.1187H22.9548V11.8765ZM22.9548 8.12653H9.01392V6.36871H22.9548V8.12653Z" />
	</svg>
);

export default IconTextToolTip;
